/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HireJobsMatchesListParams,
  JobMatch,
  JobMatchCreate,
  JobMatchCreateRequest,
  JobMatchUpdateResponse,
  JobPostingsMatchesListParams,
  PaginatedJobMatchList,
  PatchedJobMatchUpdateRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHireJobsMatchesListUrl = (jobPostingId: string,
    params?: HireJobsMatchesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/jobs/${jobPostingId}/matches/?${stringifiedParams}` : `/api/hire/jobs/${jobPostingId}/matches/`
}

/**
 * Manage job posting matches (pros matched to a job).
 */
export const hireJobsMatchesList = async (jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobMatchList> => {

  return customFetch<PaginatedJobMatchList>(getHireJobsMatchesListUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsMatchesListInfiniteQueryKey = (jobPostingId: string,
    params?: HireJobsMatchesListParams,) => {
    return [
    'infinite', `/api/hire/jobs/${jobPostingId}/matches/`, ...(params ? [params] : [])
    ] as const;
    }

export const getHireJobsMatchesListQueryKey = (jobPostingId: string,
    params?: HireJobsMatchesListParams,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/matches/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobsMatchesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hireJobsMatchesList>>, HireJobsMatchesListParams['page']>, TError = void>(jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsMatchesListInfiniteQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsMatchesList>>, QueryKey, HireJobsMatchesListParams['page']> = ({ signal, pageParam }) => hireJobsMatchesList(jobPostingId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsMatchesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesList>>>
export type HireJobsMatchesListInfiniteQueryError = void


export function useHireJobsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsMatchesList>>, HireJobsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsMatchesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsMatchesList>>, HireJobsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsMatchesList>>, HireJobsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof hireJobsMatchesList>>, HireJobsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData, QueryKey, HireJobsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsMatchesListInfiniteQueryOptions(jobPostingId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsMatchesListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsMatchesList>>, TError = void>(jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsMatchesListQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsMatchesList>>> = ({ signal }) => hireJobsMatchesList(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsMatchesListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesList>>>
export type HireJobsMatchesListQueryError = void


export function useHireJobsMatchesList<TData = Awaited<ReturnType<typeof hireJobsMatchesList>>, TError = void>(
 jobPostingId: string,
    params: undefined |  HireJobsMatchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesList<TData = Awaited<ReturnType<typeof hireJobsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesList<TData = Awaited<ReturnType<typeof hireJobsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsMatchesList<TData = Awaited<ReturnType<typeof hireJobsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: HireJobsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsMatchesListQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsMatchesCreateUrl = (jobPostingId: string,) => {




  return `/api/hire/jobs/${jobPostingId}/matches/`
}

/**
 * Manage job posting matches (pros matched to a job).
 */
export const hireJobsMatchesCreate = async (jobPostingId: string,
    jobMatchCreateRequest?: JobMatchCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobMatchCreate | JobMatchCreate[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobMatchCreate | JobMatchCreate[]>(getHireJobsMatchesCreateUrl(jobPostingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobMatchCreateRequest)
  }
);}





export const getHireJobsMatchesCreateMutationKey = () => ['hireJobsMatchesCreate'] as const;

export const getHireJobsMatchesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesCreate>>, TError,HireJobsMatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesCreate>>, TError,HireJobsMatchesCreateMutationVariables, TContext> => {

const mutationKey = getHireJobsMatchesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsMatchesCreate>>, HireJobsMatchesCreateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  hireJobsMatchesCreate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsMatchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesCreate>>>
    export type HireJobsMatchesCreateMutationBody = JobMatchCreateRequest | undefined
    export type HireJobsMatchesCreateMutationError = void
    export type HireJobsMatchesCreateMutationVariables = {jobPostingId: string;data?: JobMatchCreateRequest}

    export const useHireJobsMatchesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesCreate>>, TError,HireJobsMatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsMatchesCreate>>,
        TError,
        HireJobsMatchesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsMatchesCreateMutationOptions(options), queryClient);
    }
    export const getHireJobsMatchesRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/matches/${id}/`
}

/**
 * Manage job posting matches (pros matched to a job).
 */
export const hireJobsMatchesRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobMatch> => {

  return customFetch<JobMatch>(getHireJobsMatchesRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobsMatchesRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/hire/jobs/${jobPostingId}/matches/${id}/`
    ] as const;
    }


export const getHireJobsMatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError = void>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobsMatchesRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>> = ({ signal }) => hireJobsMatchesRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobsMatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>>
export type HireJobsMatchesRetrieveQueryError = void


export function useHireJobsMatchesRetrieve<TData = Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesRetrieve<TData = Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobsMatchesRetrieve<TData = Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobsMatchesRetrieve<TData = Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobsMatchesRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobsMatchesPartialUpdateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/matches/${id}/`
}

/**
 * Manage job posting matches (pros matched to a job).
 */
export const hireJobsMatchesPartialUpdate = async (jobPostingId: string,
    id: string,
    patchedJobMatchUpdateRequest?: PatchedJobMatchUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobMatchUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobMatchUpdateResponse>(getHireJobsMatchesPartialUpdateUrl(jobPostingId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobMatchUpdateRequest)
  }
);}





export const getHireJobsMatchesPartialUpdateMutationKey = () => ['hireJobsMatchesPartialUpdate'] as const;

export const getHireJobsMatchesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>, TError,HireJobsMatchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>, TError,HireJobsMatchesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getHireJobsMatchesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>, HireJobsMatchesPartialUpdateMutationVariables> = (props) => {
          const {jobPostingId,id,data} = props ?? {};

          return  hireJobsMatchesPartialUpdate(jobPostingId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsMatchesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>>
    export type HireJobsMatchesPartialUpdateMutationBody = PatchedJobMatchUpdateRequest | undefined
    export type HireJobsMatchesPartialUpdateMutationError = void
    export type HireJobsMatchesPartialUpdateMutationVariables = {jobPostingId: string;id: string;data?: PatchedJobMatchUpdateRequest}

    export const useHireJobsMatchesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>, TError,HireJobsMatchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsMatchesPartialUpdate>>,
        TError,
        HireJobsMatchesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsMatchesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getHireJobsMatchesDestroyUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/hire/jobs/${jobPostingId}/matches/${id}/`
}

/**
 * Manage job posting matches (pros matched to a job).
 */
export const hireJobsMatchesDestroy = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getHireJobsMatchesDestroyUrl(jobPostingId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHireJobsMatchesDestroyMutationKey = () => ['hireJobsMatchesDestroy'] as const;

export const getHireJobsMatchesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesDestroy>>, TError,HireJobsMatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesDestroy>>, TError,HireJobsMatchesDestroyMutationVariables, TContext> => {

const mutationKey = getHireJobsMatchesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobsMatchesDestroy>>, HireJobsMatchesDestroyMutationVariables> = (props) => {
          const {jobPostingId,id} = props ?? {};

          return  hireJobsMatchesDestroy(jobPostingId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobsMatchesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobsMatchesDestroy>>>

    export type HireJobsMatchesDestroyMutationError = void
    export type HireJobsMatchesDestroyMutationVariables = {jobPostingId: string;id: string}

    export const useHireJobsMatchesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobsMatchesDestroy>>, TError,HireJobsMatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobsMatchesDestroy>>,
        TError,
        HireJobsMatchesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobsMatchesDestroyMutationOptions(options), queryClient);
    }
    export const getJobPostingsMatchesListUrl = (jobPostingId: string,
    params?: JobPostingsMatchesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/job-postings/${jobPostingId}/matches/?${stringifiedParams}` : `/api/job-postings/${jobPostingId}/matches/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_posting_id}/matches/ instead. Behaviour is identical.
 *
 * Manage job posting matches (pros matched to a job).
 * @deprecated
 */
export const jobPostingsMatchesList = async (jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobMatchList> => {

  return customFetch<PaginatedJobMatchList>(getJobPostingsMatchesListUrl(jobPostingId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobPostingsMatchesListInfiniteQueryKey = (jobPostingId: string,
    params?: JobPostingsMatchesListParams,) => {
    return [
    'infinite', `/api/job-postings/${jobPostingId}/matches/`, ...(params ? [params] : [])
    ] as const;
    }

export const getJobPostingsMatchesListQueryKey = (jobPostingId: string,
    params?: JobPostingsMatchesListParams,) => {
    return [
    `/api/job-postings/${jobPostingId}/matches/`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobPostingsMatchesListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof jobPostingsMatchesList>>, JobPostingsMatchesListParams['page']>, TError = void>(jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobPostingsMatchesListInfiniteQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobPostingsMatchesList>>, QueryKey, JobPostingsMatchesListParams['page']> = ({ signal, pageParam }) => jobPostingsMatchesList(jobPostingId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobPostingsMatchesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesList>>>
export type JobPostingsMatchesListInfiniteQueryError = void


export function useJobPostingsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobPostingsMatchesList>>, JobPostingsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params: undefined |  JobPostingsMatchesListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobPostingsMatchesList>>, JobPostingsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobPostingsMatchesList>>, JobPostingsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobPostingsMatchesListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof jobPostingsMatchesList>>, JobPostingsMatchesListParams['page']>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData, QueryKey, JobPostingsMatchesListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobPostingsMatchesListInfiniteQueryOptions(jobPostingId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobPostingsMatchesListQueryOptions = <TData = Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError = void>(jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobPostingsMatchesListQueryKey(jobPostingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobPostingsMatchesList>>> = ({ signal }) => jobPostingsMatchesList(jobPostingId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobPostingsMatchesListQueryResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesList>>>
export type JobPostingsMatchesListQueryError = void


export function useJobPostingsMatchesList<TData = Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError = void>(
 jobPostingId: string,
    params: undefined |  JobPostingsMatchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesList<TData = Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesList>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesList<TData = Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobPostingsMatchesList<TData = Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError = void>(
 jobPostingId: string,
    params?: JobPostingsMatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobPostingsMatchesListQueryOptions(jobPostingId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobPostingsMatchesCreateUrl = (jobPostingId: string,) => {




  return `/api/job-postings/${jobPostingId}/matches/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_posting_id}/matches/ instead. Behaviour is identical.
 *
 * Manage job posting matches (pros matched to a job).
 * @deprecated
 */
export const jobPostingsMatchesCreate = async (jobPostingId: string,
    jobMatchCreateRequest?: JobMatchCreateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobMatchCreate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobMatchCreate>(getJobPostingsMatchesCreateUrl(jobPostingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobMatchCreateRequest)
  }
);}





export const getJobPostingsMatchesCreateMutationKey = () => ['jobPostingsMatchesCreate'] as const;

export const getJobPostingsMatchesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesCreate>>, TError,JobPostingsMatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesCreate>>, TError,JobPostingsMatchesCreateMutationVariables, TContext> => {

const mutationKey = getJobPostingsMatchesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobPostingsMatchesCreate>>, JobPostingsMatchesCreateMutationVariables> = (props) => {
          const {jobPostingId,data} = props ?? {};

          return  jobPostingsMatchesCreate(jobPostingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobPostingsMatchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesCreate>>>
    export type JobPostingsMatchesCreateMutationBody = JobMatchCreateRequest | undefined
    export type JobPostingsMatchesCreateMutationError = void
    export type JobPostingsMatchesCreateMutationVariables = {jobPostingId: string;data?: JobMatchCreateRequest}

    /**
 * @deprecated
 */
export const useJobPostingsMatchesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesCreate>>, TError,JobPostingsMatchesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobPostingsMatchesCreate>>,
        TError,
        JobPostingsMatchesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getJobPostingsMatchesCreateMutationOptions(options), queryClient);
    }
    export const getJobPostingsMatchesRetrieveUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/job-postings/${jobPostingId}/matches/${id}/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_posting_id}/matches/ instead. Behaviour is identical.
 *
 * Manage job posting matches (pros matched to a job).
 * @deprecated
 */
export const jobPostingsMatchesRetrieve = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobMatch> => {

  return customFetch<JobMatch>(getJobPostingsMatchesRetrieveUrl(jobPostingId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobPostingsMatchesRetrieveQueryKey = (jobPostingId: string,
    id: string,) => {
    return [
    `/api/job-postings/${jobPostingId}/matches/${id}/`
    ] as const;
    }


export const getJobPostingsMatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError = void>(jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobPostingsMatchesRetrieveQueryKey(jobPostingId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>> = ({ signal }) => jobPostingsMatchesRetrieve(jobPostingId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobPostingId !== null && jobPostingId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobPostingsMatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>>
export type JobPostingsMatchesRetrieveQueryError = void


export function useJobPostingsMatchesRetrieve<TData = Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesRetrieve<TData = Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobPostingsMatchesRetrieve<TData = Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useJobPostingsMatchesRetrieve<TData = Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError = void>(
 jobPostingId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobPostingsMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobPostingsMatchesRetrieveQueryOptions(jobPostingId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getJobPostingsMatchesPartialUpdateUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/job-postings/${jobPostingId}/matches/${id}/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_posting_id}/matches/ instead. Behaviour is identical.
 *
 * Manage job posting matches (pros matched to a job).
 * @deprecated
 */
export const jobPostingsMatchesPartialUpdate = async (jobPostingId: string,
    id: string,
    patchedJobMatchUpdateRequest?: PatchedJobMatchUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobMatchUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobMatchUpdateResponse>(getJobPostingsMatchesPartialUpdateUrl(jobPostingId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedJobMatchUpdateRequest)
  }
);}





export const getJobPostingsMatchesPartialUpdateMutationKey = () => ['jobPostingsMatchesPartialUpdate'] as const;

export const getJobPostingsMatchesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>, TError,JobPostingsMatchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>, TError,JobPostingsMatchesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getJobPostingsMatchesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>, JobPostingsMatchesPartialUpdateMutationVariables> = (props) => {
          const {jobPostingId,id,data} = props ?? {};

          return  jobPostingsMatchesPartialUpdate(jobPostingId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobPostingsMatchesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>>
    export type JobPostingsMatchesPartialUpdateMutationBody = PatchedJobMatchUpdateRequest | undefined
    export type JobPostingsMatchesPartialUpdateMutationError = void
    export type JobPostingsMatchesPartialUpdateMutationVariables = {jobPostingId: string;id: string;data?: PatchedJobMatchUpdateRequest}

    /**
 * @deprecated
 */
export const useJobPostingsMatchesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>, TError,JobPostingsMatchesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobPostingsMatchesPartialUpdate>>,
        TError,
        JobPostingsMatchesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getJobPostingsMatchesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getJobPostingsMatchesDestroyUrl = (jobPostingId: string,
    id: string,) => {




  return `/api/job-postings/${jobPostingId}/matches/${id}/`
}

/**
 * Deprecated — use /api/hire/jobs/{job_posting_id}/matches/ instead. Behaviour is identical.
 *
 * Manage job posting matches (pros matched to a job).
 * @deprecated
 */
export const jobPostingsMatchesDestroy = async (jobPostingId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getJobPostingsMatchesDestroyUrl(jobPostingId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getJobPostingsMatchesDestroyMutationKey = () => ['jobPostingsMatchesDestroy'] as const;

export const getJobPostingsMatchesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>, TError,JobPostingsMatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>, TError,JobPostingsMatchesDestroyMutationVariables, TContext> => {

const mutationKey = getJobPostingsMatchesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>, JobPostingsMatchesDestroyMutationVariables> = (props) => {
          const {jobPostingId,id} = props ?? {};

          return  jobPostingsMatchesDestroy(jobPostingId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobPostingsMatchesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>>

    export type JobPostingsMatchesDestroyMutationError = void
    export type JobPostingsMatchesDestroyMutationVariables = {jobPostingId: string;id: string}

    /**
 * @deprecated
 */
export const useJobPostingsMatchesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>, TError,JobPostingsMatchesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobPostingsMatchesDestroy>>,
        TError,
        JobPostingsMatchesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getJobPostingsMatchesDestroyMutationOptions(options), queryClient);
    }
